import { Link } from 'react-router-dom'
import { motion, useReducedMotion } from 'framer-motion'
import { cn } from '@/lib/utils'

export interface LandingButtonProps {
  to: string
  children: React.ReactNode
  className?: string
  variant?: 'primary' | 'secondary'
  size?: 'sm' | 'md' | 'lg'
}

export function LandingButton({
  to,
  children,
  className,
  variant = 'primary',
  size = 'md',
}: LandingButtonProps) {
  const prefersReducedMotion = useReducedMotion()

  const variants = {
    primary: {
      base: 'bg-accent text-accent-foreground shadow-[0_4px_24px_rgba(232,152,90,0.3)]',
      hover: {
        y: -2,
        scale: 1.02,
        boxShadow: '0 8px 32px rgba(232,152,90,0.35)',
      },
    },
    secondary: {
      base: 'bg-background border border-border text-foreground hover:bg-muted',
      hover: {
        y: -1,
        boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
      },
    },
  }

  const sizes = {
    sm: 'px-7 py-2.5 text-sm font-bold',
    md: 'px-10 py-4 text-base font-bold',
    lg: 'px-12 py-[18px] text-lg font-bold',
  }

  return (
    <motion.div
      whileHover={prefersReducedMotion ? {} : variants[variant].hover}
      transition={{ type: 'spring', stiffness: 400, damping: 25 }}
      className={cn(
        'inline-flex items-center justify-center rounded-full transition-colors',
        variants[variant].base,
        sizes[size],
        className
      )}
    >
      <Link to={to} className="flex items-center gap-2.5">
        {children}
      </Link>
    </motion.div>
  )
}
